import React, { useState } from 'react'
import Reviews from '../../../components/Front/Reviews/Reviews'
import OsobniDoucovaniBanner from '../../../assets/images/front/osobni-doucovani-banner.png'
import OsobniDoucovaniBannerMobile from '../../../assets/images/front/osobni-doucovani-banner-mobile.png'
import OsobniDoucovaniBannerGraphics from '../../../assets/images/front/osobni-doucovani-banner-graphics.png'
import OsobniDoucovaniButton from '../../../assets/images/front/svg/osobni-doucovani-button.svg'
import HandImage from '../../../assets/images/front/ruka.png'
import Image390 from '../../../assets/images/front/390.png'
import SelectArrow from '../../../assets/images/front/svg/select-arrow.svg'
import Matematika from '../../../assets/images/front/svg/matematika.svg'
import Cesky from '../../../assets/images/front/svg/cesky.svg'
import Prirodopis from '../../../assets/images/front/svg/prirodopis.svg'
import Vlastiveda from '../../../assets/images/front/svg/vlastiveda.svg'
import CiziJazyk from '../../../assets/images/front/svg/cizi-jazyk.svg'
import Fyzika from '../../../assets/images/front/svg/fyzika.svg'
import Zemepis from '../../../assets/images/front/svg/zemepis.svg'
import ArrowDownWhite from '../../../assets/images/front/svg/arrow-down-white.svg'
import SignPost1 from '../../../assets/images/front/signpost-1.png'
import SignPost2 from '../../../assets/images/front/signpost-2.png'
import FAQAccordion from '../../../components/Front/FaqAccordion/FaqAccordion'
import Contacts from '../../../components/Front/Contacts/Contacts'
import { PrivateClassType } from '../../../components/Forms/form-types'
import { sendPrivateClassRequest } from '../../../moduls/private-class'
import { pushDataLayer } from '../../../services/utils'

const accordionData = [
  {
    title: 'Matematika',
    icon: Matematika,
    content: `Potřebuje vaše dítě doučování matematiky? Zhoršený prospěch v matematice se dá často
      napravit individuálním výkladem a procvičováním ustálených matematických postupů. I
      nedostatek logického myšlení se dá vylepšovat pomocí různých zábavných úkolů. Dítě
      získá sebevědomí a matematika pro něj přestane být strašákem.`
  },
  {
    title: 'Český jazyk',
    icon: Cesky,
    content: `Pomůžeme vašemu dítěti s gramatikou, slohem i porozuměním textu. Individuální
      přístup vede k lepším výsledkům a větší jistotě v českém jazyce.`
  },
  {
    title: 'Přírodopis',
    icon: Prirodopis,
    content: `Zajistíme, aby přírodopis nebyl jen o memorování, ale i o pochopení souvislostí v
      přírodě. Podpoříme zájem o biologii a ekologii.`
  },
  {
    title: 'Vlastivěda',
    icon: Vlastiveda,
    content: `Pomůžeme s orientací v historii, zeměpisu i občanské výchově. Dítě získá přehled a
      jistotu v základních společenských vědách.`
  },
  {
    title: 'Cizí jazyk',
    icon: CiziJazyk,
    content: `Individuální doučování cizích jazyků pomůže s gramatikou, slovní zásobou i
      konverzací. Přizpůsobíme se úrovni a potřebám dítěte.`
  },
  {
    title: 'Fyzika a chemie',
    icon: Fyzika,
    content: `Vysvětlíme fyzikální a chemické jevy srozumitelně a názorně. Pomůžeme s přípravou na
      testy i s domácími úkoly.`
  },
  {
    title: 'Zeměpis, dějepis, občanská výchova',
    icon: Zemepis,
    content: `Pomůžeme s pochopením zeměpisných, historických i společenských témat. Dítě získá
      jistotu v orientaci ve světě kolem sebe.`
  }
]

const PrivateClass: React.FC = () => {
  const [openIndexes, setOpenIndexes] = useState<number[]>([])
  const [errors, setErrors] = useState<Record<string, string>>({})

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    const form = e.currentTarget
    const formData = new FormData(form)

    const newErrors: Record<string, string> = {}

    const name = formData.get('name')?.toString().trim() || ''
    const email = formData.get('email')?.toString().trim() || ''
    const phone = formData.get('phone')?.toString().trim() || ''
    const gdpr = formData.get('gdpr')

    if (!name) newErrors.name = 'Zadejte prosím jméno.'
    if (!email || !/\S+@\S+\.\S+/.test(email)) newErrors.email = 'Zadejte platný e-mail.'
    if (!phone || !/^[0-9 +()-]{6,20}$/.test(phone)) newErrors.phone = 'Zadejte platný telefon.'
    if (!gdpr) newErrors.gdpr = 'Musíte souhlasit s GDPR.'

    setErrors(newErrors)

    if (Object.keys(newErrors).length > 0) {
      return
    }

    const data: PrivateClassType = {
      name: formData.get('name')?.toString() || '',
      address: formData.get('address')?.toString() || '',
      phone: formData.get('phone')?.toString() || '',
      email: formData.get('email')?.toString() || '',
      date: formData.get('date')?.toString() || '',
      discover: formData.get('discover')?.toString() || '',
      subject: formData.get('subject')?.toString() || '',
      class: formData.get('class')?.toString() || '',
      message: formData.get('message')?.toString() || '',
      gdpr: !!formData.get('gdpr')
    }

    try {
      await sendPrivateClassRequest(data)
      pushDataLayer({
        'event': 'generate_lead',
        'lead_type': 'osobni-doucovani'
      });
      window.toggleNotification('success', 'Formulář byl úspěšně odeslán')
      form.reset()
      setErrors({})
    } catch (error) {
      window.toggleNotification('error', 'Ups, něco se pokazilo')
    }
  }

  // Only allow one open at a time
  const toggleAccordion = (idx: number) => {
    setOpenIndexes((prev) => (prev.includes(idx) ? [] : [idx]))
  }

  const formRef = React.useRef<HTMLFormElement | null>(null)
  const scrollToForm = () => {
    if (formRef.current) {
      const y = formRef.current.getBoundingClientRect().top + window.pageYOffset - 100
      window.scrollTo({ top: y, behavior: 'smooth' })
    }
  }

  return (
    <>
      <div className="container relative mx-auto md:px-4 mt-[52px] lg:mt-[84px]">
        <img
          src={OsobniDoucovaniBanner}
          alt=""
          className="w-full min-h-[350px] h-auto hidden md:block object-cover rounded-b-3xl"
        />
        <img
          src={OsobniDoucovaniBannerMobile}
          alt=""
          className="w-full min-h-[350px] h-auto md:hidden object-cover"
        />
        <div className="absolute left-[50%] translate-x-[-50%] md:translate-x-0 md:left-8 top-4 w-full px-4">
          <img
            src={OsobniDoucovaniBannerGraphics}
            alt=""
            className="w-full max-w-[520px] h-auto object-cover"
          />
        </div>
        <div className="absolute right-[-50%] translate-x-[-50%] md:translate-x-0 bottom-10 md:right-20 md:bottom-20 flex md:block items-center justify-center w-full md:w-auto">
          <span
            onClick={scrollToForm}
            className="inline-block text-2xl md:text-4xl pt-3 text-white bg-[#00A0E3] hover:bg-[#0183BA] tracking-wide leading-tight px-10 py-2 rounded-xl transition-colors duration-200 relative"
          >
            Objednat doučování
            <img
              src={OsobniDoucovaniButton}
              alt=""
              className="absolute top-[30%] translate-y-[-50%] -right-10 w-[100px] hidden md:block"
            />
            <img src={Image390} alt="" className="absolute w-[60px] -top-10 -right-8 md:hidden" />
            <img
              src={HandImage}
              alt=""
              className="absolute w-[60px] -bottom-9 left-[50%] translate-x-[-50%] md:hidden"
            />
          </span>
        </div>
      </div>
      <div className="container mx-auto px-4 my-12">
        <div className="grid grid-cols-12 gap-4 mx-auto max-w-[820px]">
          <div className="col-span-12 md:col-span-6 relative group text-white">
            <img src={SignPost1} alt="" className="w-full h-auto object-cover rounded-3xl" />
            <span className="block w-full py-2 bg-[#A8CD00] absolute bottom-0 left-0 rounded-b-3xl flex items-center justify-center">
              jak to funguje?
            </span>
            <div className="absolute top-0 left-0 border rounded-3xl bg-white border-[#A8CD00] w-full h-full p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <h3 className="text-lg text-[#0183BA] mb-0 text-center">jak to funguje?</h3>
              <p className="leading-tight text-black">
                V případě zájmu o doučování stačí vyplnit formulář, který naleznete
                <a
                  href="javascript:void(0);"
                  className="underline hover:text-[#0183BA] transition-colors duration-300 cursor-pointer"
                  onClick={scrollToForm}
                >
                  &nbsp;zde
                </a>
                . V nejkratším možném čase pro vás vybereme vhodného lektora. Předáme vám informace
                o lektorovi a ten si s vámi domluví první doučování. Při této návštěvě se lektor
                seznámí s dítětem a sestaví učební plán, který bude dítěti nejlépe vyhovovat. Lektor
                k vám dále bude pravidelně docházet tak, jak se domluvíte.
              </p>
            </div>
          </div>
          <div className="col-span-12 md:col-span-6 relative group text-white">
            <img src={SignPost2} alt="" className="w-full h-auto object-cover rounded-3xl" />
            <span className="block w-full py-2 bg-[#00A0E3] absolute bottom-0 left-0 rounded-b-3xl flex items-center justify-center">
              jde to i on-line!
            </span>
            <div className="absolute top-0 left-0 border rounded-3xl bg-white border-[#00A0E3] w-full h-full p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <h3 className="text-lg text-[#0183BA] mb-0 text-center">jde to i on-line!</h3>
              <p className="leading-tight text-black">
                Doučování může probíhat i online formou. Pokud máte strach z aktuální covidové
                situace nebo z toho, že při uzavření škol zůstanete na vyučování svého dítěte sami,
                nemusíte se bát. My vás v tom nenecháme. Stačí vám jen notebook a připojení k
                internetu.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#00A0E3] w-full py-8">
        <h2 className="text-wrapper-16 mb-12 text-white text-center">Nejčastější otázky</h2>
        <FAQAccordion />
      </div>
      <div className="container mx-auto px-4 my-12">
        <div className="grid grid-cols-12 gap-4">
          {accordionData.map((item, idx) => (
            <div
              key={item.title}
              className={`col-span-12 ${idx === accordionData.length - 1 ? '' : 'lg:col-span-6'}`}
            >
              <div
                className={`cursor-pointer rounded-xl border border-[#A8CD00] w-full overflow-hidden`}
              >
                <div
                  className={`text-xl lg:text-5xl flex items-center ps-24 pe-4 pt-3 py-2 rounded-t-xl bg-left bg-no-repeat w-full bg-[#A8CD00] hover:bg-[#8FB200] transition-all duration-300 text-white`}
                  style={{ backgroundImage: `url('${item.icon}')`, backgroundSize: '80px' }}
                  onClick={() => toggleAccordion(idx)}
                  role="button"
                  tabIndex={0}
                  aria-expanded={openIndexes.includes(idx)}
                >
                  {item.title}
                  <img
                    src={ArrowDownWhite}
                    alt=""
                    className={`ms-auto accordion-arrow transition-transform duration-300${
                      openIndexes.includes(idx) ? ' rotate-180' : ''
                    }`}
                  />
                </div>
                <div
                  className={`p-4 font-myriad transition-all duration-300${
                    openIndexes.includes(idx) ? '' : ' hidden'
                  }`}
                >
                  {item.content}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="container pt-6 md:pt-12 mx-4 px-4">
        <div className="grid grid-cols-10 gap-4">
          <div className="col-span-12 text-center mb-8">
            <p>
              Neváhejte kontaktovat Johanku pro další informace. Děláme vše proto, abychom vyučování
              <br />
              přizpůsobili potřebám vašeho dítěte.
            </p>
          </div>
        </div>
      </div>
      <div className="pb-6 md:pb-12">
        <Contacts />
      </div>
      <div className="container mx-auto px-4 border-t border-b border-[#A8CD00] py-8 mb-8">
        <div className="grid grid-cols-12 gap-4 mb-4">
          <div className="col-span-12 md:col-span-4 text-center">
            <h3 className="uppercase text-lg lg:text-[25px] text-[#0183BA]">
              varianty předplatného
            </h3>
          </div>
          <div className="col-span-12 md:col-span-8 font-myriad">
            <strong>Online doučování</strong>
            <br />
            <div className="mb-3">
              A) <strong>1&nbsp;950&nbsp;Kč</strong> - 5 lekcí <br />
              B) <strong>3&nbsp;900&nbsp;Kč</strong> - 10 lekcí <br />
            </div>
            <strong>Osobní doučování (u vás doma)</strong>
            <br />
            <div className="mb-3">
              A) <strong>2&nbsp;200&nbsp;Kč</strong> - 5 lekcí <br />
              B) <strong>4&nbsp;400&nbsp;Kč</strong> - 10 lekcí <br />
            </div>
            <p>V případě jednorázového doučování se na ceně domluvíme telefonicky.</p>
          </div>
        </div>
        <form action="" onSubmit={handleSubmit} ref={formRef}>
          <div className="grid grid-cols-12 gap-4 font-myriad">
            <div className="col-span-12 md:col-span-6 text-[#0183BA]">
              <label htmlFor="name" className="font-bold">
                Vaše jméno <span className="text-[#A8CD00]">*</span>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className={`w-full font-normal p-2 rounded-lg border ${
                    errors.name ? 'border-[#A8CD00]' : 'border-[#00A0E3]'
                  }`}
                />
              </label>
              {errors.name && <p className="text-[#A8CD00] text-sm mt-1">{errors.name}</p>}
            </div>
            <div className="col-span-12 md:col-span-6 text-[#0183BA]">
              <label htmlFor="address" className="font-bold">
                Adresa
                <input
                  type="text"
                  id="address"
                  name="address"
                  className="w-full font-normal p-2 border border-[#00A0E3] rounded-lg"
                />
              </label>
            </div>
            <div className="col-span-12 md:col-span-6 text-[#0183BA]">
              <label htmlFor="phone" className="font-bold">
                Telefon <span className="text-[#A8CD00]">*</span>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  className={`w-full font-normal p-2 rounded-lg border ${
                    errors.phone ? 'border-[#A8CD00]' : 'border-[#00A0E3]'
                  }`}
                />
              </label>
              {errors.phone && <p className="text-[#A8CD00] text-sm mt-1">{errors.phone}</p>}
            </div>
            <div className="col-span-12 md:col-span-6 text-[#0183BA]">
              <label htmlFor="email" className="font-bold">
                E-mail <span className="text-[#A8CD00]">*</span>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className={`w-full font-normal p-2 rounded-lg border ${
                    errors.email ? 'border-[#A8CD00]' : 'border-[#00A0E3]'
                  }`}
                />
              </label>
              {errors.email && <p className="text-[#A8CD00] text-sm mt-1">{errors.email}</p>}
            </div>
            <div className="col-span-12 md:col-span-6 text-[#0183BA]">
              <label htmlFor="date" className="font-bold">
                Den/dny v týdnu a preferovaný čas doučování
                <input
                  type="text"
                  id="date"
                  name="date"
                  className="w-full font-normal p-2 border border-[#00A0E3] rounded-lg"
                />
              </label>
            </div>
            <div className="col-span-12 md:col-span-6 text-[#0183BA]">
              <label htmlFor="discover" className="font-bold">
                Jak jste se o nás dozvěděli
                <select
                  id="discover"
                  name="discover"
                  className="w-full font-normal p-2 border border-[#00A0E3] rounded-lg appearance-none bg-no-repeat pr-8"
                  style={{
                    backgroundImage: `url(${SelectArrow})`,
                    backgroundPosition: 'right 0.5rem center'
                  }}
                >
                  <option value=""></option>
                  <option value="google">Google</option>
                  <option value="facebook">Facebook</option>
                  <option value="instagram">Instagram</option>
                  <option value="youtube">YouTube</option>
                  <option value="friend">Přítel</option>
                  <option value="other">Jiné</option>
                </select>
              </label>
            </div>
            <div className="col-span-12 md:col-span-4 text-[#0183BA]">
              <label htmlFor="subject" className="font-bold">
                Předmět
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  className="w-full font-normal p-2 border border-[#00A0E3] rounded-lg"
                />
              </label>
            </div>
            <div className="col-span-12 md:col-span-4 text-[#0183BA]">
              <label htmlFor="class" className="font-bold">
                Třída
                <input
                  type="text"
                  id="class"
                  name="class"
                  className="w-full font-normal p-2 border border-[#00A0E3] rounded-lg"
                />
              </label>
            </div>
            <div className="col-span-12 md:col-span-4 text-[#0183BA]">
              <label htmlFor="class" className="font-bold">
                Forma doučování
                <select
                  id="class"
                  name="class"
                  className="w-full font-normal p-2 border border-[#00A0E3] rounded-lg appearance-none bg-no-repeat pr-8"
                  style={{
                    backgroundImage: `url(${SelectArrow})`,
                    backgroundPosition: 'right 0.5rem center'
                  }}
                >
                  <option value=""></option>
                  <option value="1">Osobně</option>
                  <option value="2">Online</option>
                  <option value="3">Osobně i Online</option>
                </select>
              </label>
            </div>
            <div className="col-span-12 text-[#0183BA]">
              <label htmlFor="class" className="font-bold">
                Chcete nám ještě něco vzkázat?
                <textarea
                  name="message"
                  id="message"
                  className="w-full font-normal p-2 border border-[#00A0E3] rounded-lg"
                  rows={4}
                ></textarea>
              </label>
            </div>
            <div className="col-span-12">
              <div className="flex items-center text-[#0183BA]">
                <input
                  type="checkbox"
                  id="gdpr"
                  name="gdpr"
                  className="me-2 accent-[#00A0E3] w-5 h-5 border ${
                    errors.gdpr ? 'border-red-500' : 'border-[#00A0E3]'
                  } text-white rounded-lg"
                  required
                />
                <label htmlFor="gdpr" className="font-myriad font-bold">
                  Souhlasím s{' '}
                  <a href="#" className="underline">
                    obchodními podmínkami
                  </a>{' '}
                  a{' '}
                  <a href="#" className="underline">
                    GDPR
                  </a>
                  <span className="text-red-500">*</span>
                </label>
              </div>
            </div>
            <div className="col-span-12 text-center">
              <button
                type="submit"
                className="py-2 px-12 bg-[#A8CD00] hover:bg-[#8FB200] transition-colors duration-300 text-white rounded-lg cursor-pointer"
              >
                Odeslat
              </button>
            </div>
          </div>
        </form>
      </div>
      <div className="-mb-12">
        <div className="HP">
          <Reviews />
        </div>
      </div>
    </>
  )
}

export default PrivateClass
